module.exports = __webpack_public_path__ + "h5/media/s_wheel.bc82b4df.mp3";